import { useEffect } from 'react'

type UseUnsavedChangesWarningOptions = {
  /**
   * When true, shows the browser's default leave/refresh warning
   * ("Leave site? Changes you made may not be saved.").
   * Typically: `addOpen && isDirty && !isSubmitting`
   */
  when: boolean
}

/**
 * Prompts the browser's native unsaved-changes dialog on refresh, tab close,
 * or navigation away while `when` is true.
 */
export const useUnsavedChangesWarning = ({ when }: UseUnsavedChangesWarningOptions) => {
  useEffect(() => {
    if (!when) return

    const onBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault()
      // Required for Chrome / older browsers to show the native dialog.
      event.returnValue = ''
    }

    window.addEventListener('beforeunload', onBeforeUnload)
    return () => window.removeEventListener('beforeunload', onBeforeUnload)
  }, [when])
}

export default useUnsavedChangesWarning
